import axios from 'axios'

export default {
  state: {
    successfulOrderInfo: null,
    emailResponse: null
  },
  mutations: {
    SET_SUCCESSFUL_ORDER_INFO: (state, info) => {
      state.successfulOrderInfo = info
    },
    SET_EMAIL_RESPONSE: (state, info) => {
      state.emailResponse = info
    }
  },
  actions: {
    SEND_EMAIL_NOTIFICATION: (ctx, data) => {
      return new Promise(resolve => {
        axios.get(ctx.rootGetters.urlLanguagePrefix + '/cabinet/order/send-email-invoice/', {
          params: {
            orderId: data.orderId,
            email: data.email
          }
        })
          .then(response => {
            resolve(response.data)
            if (response.data.status === 'error') {
              ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('error_occurred'))
              return
            }
            ctx.commit('SET_EMAIL_RESPONSE', response.data)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('error_occurred')))
      })
    },
    SEND_SMS_NOTIFICATION: (ctx, data) => {
      return new Promise(resolve => {
        const params = {
          order_id: data.orderId
        }

        axios.post(ctx.rootGetters.urlLanguagePrefix + '/shop/catalog/resend-invoice/', params)
          .then(response => {
            if (!response.data.success) {
              ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('error_occurred'))
            }
            resolve(response.data)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('error_occurred')))
      })
    },
    FETCH_SUCCESSFUL_ORDER_INFO: (ctx, orderId) => {
      return new Promise(resolve => {
        axios.get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-order-data/', { params: { order_id: orderId } })
          .then(response => {
            if (response.data.order.status) {
              ctx.commit('SET_SUCCESSFUL_ORDER_INFO', response.data.order)
            }

            resolve(response.data.order)
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('error_occurred')))
      })
    }
  }
}
